<template>

<app-screen title="Terms" :back="(loggedin) ? false : 'Login'" :textOnly="true" :menu="loggedin" class="screen-rules">

	<div v-html="texts.terms"></div>
	
</app-screen>

</template>

<script>

export default {

}

</script>

<style scoped>

.screen-rules {
	background-color: #fff!important;
}

</style>
